import React from 'react';
import { Outlet } from 'react-router-dom';

// Thin content shell for the Assessments hub. Its own navigation (Browse
// Assessments, My Passport, Assessment Engine, Question Bank, Paper
// Designer, Reports, Certificates) now lives inside the shared global side
// nav as child rows under "Assessments" (see PRIMARY_ITEM_CHILDREN in
// src/lib/sideNavConfig.js) rather than a standalone sidebar here.
export default function AssessmentLayout() {
  return (
    <main className="min-w-0 flex-1 px-0">
      <div className="min-h-screen px-4 pb-10 pt-4 sm:px-6 lg:px-8">
        <Outlet />
      </div>
    </main>
  );
}
